import { ServiceInfo } from './../models/display/serviceInfo';
import { UserApi } from 'src/app/models/api_models/user';
import { UserApiService } from './../user-api.service';
import { CookieService } from 'ngx-cookie-service';
import { DomSanitizer } from '@angular/platform-browser';
import { ActivatedRoute, Router } from '@angular/router';
import { MatSnackBar } from '@angular/material/snack-bar';
import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-autologin',
  templateUrl: './autologin.component.html',
  styleUrls: ['./autologin.component.scss']
})
export class AutologinComponent implements OnInit {

  constructor(private userApiService: UserApiService, private cookieService: CookieService, public snackBar: MatSnackBar, private activatedRoute: ActivatedRoute, public router: Router, private domSanitizer: DomSanitizer) { this.getCurrentRoute() }

  submitted = false;
  loading = false;

  currentToken: any;

  querystation: any


  _currentUser: UserApi;
  isUserLoad: boolean = false;
  _servicesList: ServiceInfo[] = [];


  maxDate = new Date();
  birthday: Date
  childYear = new Date().getFullYear() - 18;


  private sub: any;

  ngOnInit(): void {

    // window.location.reload()

  }



  getCurrentRoute() {

    this.sub = this.activatedRoute.queryParamMap.subscribe(query => {


      this.querystation = parseInt(query.get('station')) || 0
      let querytoken: any = query.get('token') || null
      console.log(query)
      console.log('----station-----')
      console.log(this.querystation)
      console.log('querytoken')
      console.log(querytoken)


      let expiredDate = new Date();
      expiredDate.setDate(expiredDate.getDate() + 7);
      let token = { "access_token": querytoken, "refresh_token": null, "expires_in": expiredDate, "grant_type": "user_grant" }
      localStorage.setItem('token_clem_mobi', JSON.stringify(token));



    });






    this.userApiService.getCurrentUserData().subscribe(
      response => {

        console.log("reservation ghiiiiiiiiiiii")
        console.log(response)

        if (response) {
          console.log(response.name)

          if (this.querystation === 0 ) {
            this.router.navigate([`/`]).then(ok => {
              window.location.reload();
            });
          }
          else {
            this.router.navigateByUrl(`/?station=${this.querystation}`).then(ok => {
              window.location.reload();
            });
          }

        }
      },
      error => {
        console.log(error)
      }
    );

  }






  // ngOnDestroy() {
  //   this.sub.unsubscribe();
  //   // window.location.reload()
  // }





  openSnackBar(message: string) {
    this.snackBar.open(message, "X", {
      panelClass: ['sucess-snackbar'],
      duration: 5000,
    });
  }

}
